import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Printer, ArrowLeft } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { tplById } from "@/lib/suratTemplates";
import { SuratDoc } from "@/components/SuratDoc";
import { usePejabat } from "@/context/PejabatContext";

export default function CetakSurat() {
  const { id } = useParams();
  const { pejabat } = usePejabat();
  const [s, setS] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/surat/${id}`).then((r) => setS(r.data)).catch((e) => setErr(errMsg(e)));
  }, [id]);
  const tpl = s && tplById(s.jenis);

  return (
    <div className="min-h-screen bg-slate-300 py-8 px-4 print:p-0 print:bg-white" data-testid="cetak-surat-page">
      <style>{"@media print { @page { size: A4 portrait; margin: 0; } }"}</style>
      <div className="no-print max-w-[210mm] mx-auto flex justify-between mb-4">
        <Link to="/surat" className="inline-flex items-center gap-2 text-sm text-slate-700" data-testid="cetak-surat-back"><ArrowLeft className="h-4 w-4" /> Daftar Surat</Link>
        <button onClick={() => window.print()} className="inline-flex items-center gap-2 bg-[#0b4f4a] text-white text-sm rounded-lg px-4 py-2 hover:bg-[#072f2c]" data-testid="cetak-surat-print-button">
          <Printer className="h-4 w-4" /> Cetak / Simpan PDF
        </button>
      </div>
      {err && <div className="text-center text-rose-700" data-testid="cetak-surat-error">{err}</div>}
      {tpl && <div className="mx-auto w-fit shadow-xl print:shadow-none"><SuratDoc tpl={tpl} bio={s.data} extra={s.extra} nomor={s.nomor} tanggal={s.tanggal} pejabat={s.pejabat || pejabat} suratId={s.id} /></div>}
    </div>
  );
}
